import { useEffect, useLayoutEffect, useRef, useCallback } from 'react';

/**
 * Custom hook to handle key press events.
 *
 * @param {string[]} keys - Array of keys to listen for.
 * @param {function} callback - Function to call when one of the keys is pressed.
 * @param {HTMLElement|null} [node=null] - Optional DOM node to attach the event listener to. Defaults to `document`.
 */
const useKeyPress = (keys, callback, node = null) => {
  const callbackRef = useRef(callback);
  useLayoutEffect(() => {
    callbackRef.current = callback;
  });
  const handleKeyPress = useCallback((event) => {
    if (event.altKey && event.ctrlKey && keys.find((key) => event.key === key)) {
      callbackRef.current(event);
    }
  }, [keys]);
  useEffect(() => {
    const targetNode = node ?? document;
    if (targetNode) {
      targetNode.addEventListener('keydown', handleKeyPress);
      return () => targetNode.removeEventListener('keydown', handleKeyPress);
    }
  }, [handleKeyPress, node]);
};
export default useKeyPress;